// extracted by mini-css-extract-plugin
export default {"auth__wrapper":"styles_auth__wrapper__Nuc8l","auth__error":"styles_auth__error__p1Tpf"};